import { startTransition, useState } from "react";
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect";
const useRootTheme = ({ fallback = "light" } = {}) => {
  const [val, setVal] = useState(fallback);
  return useIsomorphicLayoutEffect(() => {
    const classes = [...document.documentElement.classList], val2 = classes.includes("t_dark") ? "dark" : classes.includes("t_light") ? "light" : fallback;
    startTransition(() => {
      setVal(val2);
    });
  }, []), [val, setVal];
};
export {
  useRootTheme
};
//# sourceMappingURL=useRootTheme.js.map
